import React from "react";
import { AlertTriangle, CheckCircle2, X, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { PriceSuggestionCard } from "@/components/vehicle/PriceSuggestionCard";
import { AVAILABILITY_META, FIELD_LABELS } from "@/lib/constants";

export default function OverviewTab({ vehicle, datacheck, reload, goTab }) {
  const s = vehicle.specs || {};

  const facts = ["marke", "modell", "variante", "baujahr", "erstzulassung", "kilometerstand", "leistung_ps", "kraftstoff", "getriebe", "antrieb", "karosserie", "farbe_aussen"];

  return (
    <div className="grid lg:grid-cols-12 gap-4">
      <Card className="lg:col-span-7">
        <CardHeader className="pb-2"><CardTitle className="text-base font-display">Eckdaten</CardTitle></CardHeader>
        <CardContent className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-3 text-sm">
          {facts.map((k) =>
            s[k] != null ? (
              <div key={k}>
                <div className="text-xs text-muted-foreground">{FIELD_LABELS[k] || k}</div>
                <div className="font-medium">{k === "kilometerstand" ? `${Number(s[k]).toLocaleString("de-DE")} km` : s[k]}</div>
              </div>
            ) : null
          )}
          {vehicle.verfuegbarkeit && (
            <div>
              <div className="text-xs text-muted-foreground">Verfügbarkeit</div>
              <div className="font-medium">{AVAILABILITY_META[vehicle.verfuegbarkeit]?.label || vehicle.verfuegbarkeit}{vehicle.verfuegbarkeit === "ab_datum" && vehicle.verfuegbar_ab ? ` (${vehicle.verfuegbar_ab})` : ""}</div>
            </div>
          )}
          {(vehicle.equipment || []).length > 0 && (
            <div className="col-span-full pt-1">
              <div className="text-xs text-muted-foreground mb-1.5">Ausstattung ({vehicle.equipment.length})</div>
              <div className="flex flex-wrap gap-1.5">
                {vehicle.equipment.slice(0, 12).map((e) => (
                  <span key={e} className="rounded-full border border-border bg-secondary/50 px-2 py-0.5 text-xs">{e}</span>
                ))}
                {vehicle.equipment.length > 12 && <span className="text-xs text-muted-foreground">+{vehicle.equipment.length - 12} weitere</span>}
              </div>
            </div>
          )}
        </CardContent>
      </Card>

      <div className="lg:col-span-5 space-y-4">
        <Card data-testid="overview-datacheck-card">
          <CardHeader className="pb-2 flex-row items-center justify-between space-y-0">
            <CardTitle className="text-base font-display">Datenprüfung</CardTitle>
            <span className="text-sm tabular-nums font-medium">{datacheck.completeness_pct}%</span>
          </CardHeader>
          <CardContent className="space-y-2">
            <Progress value={datacheck.completeness_pct} className="h-1.5" />
            {datacheck.blockers.map((b, i) => (
              <div key={i} className="flex items-center gap-2 text-sm text-red-300"><X className="h-4 w-4 shrink-0" /> {b.label}</div>
            ))}
            {datacheck.warnings.map((w, i) => (
              <div key={i} className="flex items-center gap-2 text-sm text-amber-300"><AlertTriangle className="h-4 w-4 shrink-0" /> {w.label}</div>
            ))}
            {datacheck.blockers.length === 0 && datacheck.warnings.length === 0 && (
              <div className="flex items-center gap-2 text-sm text-emerald-300"><CheckCircle2 className="h-4 w-4" /> Alles vollständig – keine offenen Punkte</div>
            )}
            <Button variant="outline" size="sm" className="gap-1 mt-1" onClick={() => goTab("data")} data-testid="overview-open-datacheck">
              Zur Datenprüfung <ArrowRight className="h-3.5 w-3.5" />
            </Button>
          </CardContent>
        </Card>

        <PriceSuggestionCard vehicle={vehicle} reload={reload} />

        {vehicle.sold_info && (
          <Card>
            <CardHeader className="pb-2"><CardTitle className="text-base font-display">Verkauft</CardTitle></CardHeader>
            <CardContent className="space-y-1.5 text-sm">
              <div className="flex justify-between"><span className="text-muted-foreground">Verkaufsdatum</span><span>{vehicle.sold_info.sale_date}</span></div>
              <div className="flex justify-between"><span className="text-muted-foreground">Standtage</span><span className="tabular-nums">{vehicle.sold_info.days_in_stock}</span></div>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
}
